import { render, staticRenderFns } from "./VehicleRemarksList.vue?vue&type=template&id=3949e9a6&"
import script from "./VehicleRemarksList.vue?vue&type=script&lang=js&"
export * from "./VehicleRemarksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports